var _path, _path2, _circle, _path3, _polygon, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoAddImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.48,21.93c.71,0,1.28-.57,1.28-1.28s-.57-1.28-1.28-1.28-1.28,.57-1.28,1.28,.57,1.28,1.28,1.28Z",
    fill: filledColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,10.84h-3.97v-3.97c0-1.05-.85-1.91-1.91-1.91H5c-1.05,0-1.91,.85-1.91,1.91v28.38c0,1.05,.85,1.91,1.91,1.91h3.97v3.97c0,1.05,.85,1.91,1.91,1.91H43c1.05,0,1.91-.85,1.91-1.91V12.75c0-1.05-.85-1.91-1.91-1.91Zm-8.52,4.72c2.81,0,5.09,2.28,5.09,5.09s-2.28,5.09-5.09,5.09-5.09-2.28-5.09-5.09,2.28-5.09,5.09-5.09Zm4.86,23.66l-6.2-6.52-2.57,2.14c-.78,.65-1.94,.57-2.62-.18l-5.36-5.82-8.71,10.38h-1.08v-4.65l8.26-9.84c.35-.42,.87-.67,1.42-.68,.56,0,1.08,.21,1.45,.62l5.6,6.08,2.55-2.12c.77-.64,1.91-.58,2.6,.15l6.42,6.75,.06,3.64-1.82,.06Z",
    fill: filledColor
  })), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.56,34.84c-.78,.65-1.94,.57-2.62-.18l-5.36-5.82-8.71,10.38h25.47l-6.2-6.52-2.57,2.14Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.79,34.57l8.26-9.84c.35-.42,.87-.67,1.42-.68,.56,0,1.08,.21,1.45,.62l5.6,6.08,2.55-2.12c.77-.64,1.91-.58,2.6,.15l6.42,6.75V14.66H12.79v19.91ZM34.5,15.5c2.81,0,5.09,2.28,5.09,5.09s-2.28,5.09-5.09,5.09-5.09-2.28-5.09-5.09,2.28-5.09,5.09-5.09Z",
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 20.6,
    r: 1.28,
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97,25.99V12.75c0-1.05,.85-1.91,1.91-1.91h24.33v-2.06H6.91V28.45l2.06-2.46Z",
    fill: "none"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "7.78 33.34 8.97 33.34 8.97 31.92 7.78 33.34",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43,10.84h-3.97v-3.97c0-1.05-.85-1.91-1.91-1.91H5c-1.05,0-1.91,.85-1.91,1.91v28.38c0,1.05,.85,1.91,1.91,1.91h3.97v3.97c0,1.05,.85,1.91,1.91,1.91H43c1.05,0,1.91-.85,1.91-1.91V12.75c0-1.05-.85-1.91-1.91-1.91Zm-1.91,24.68l-6.42-6.75c-.69-.73-1.83-.79-2.6-.15l-2.55,2.12-5.6-6.08c-.37-.4-.89-.62-1.45-.62-.55,.01-1.06,.26-1.42,.68l-8.26,9.84V14.66h28.3v20.87Zm-1.75,3.69H13.87l8.71-10.38,5.36,5.82c.69,.75,1.84,.83,2.62,.18l2.57-2.14,6.2,6.52Zm-4.13-30.44v2.06H10.88c-1.05,0-1.91,.85-1.91,1.91v13.24l-2.06,2.46V8.78h28.3ZM7.78,33.34l1.19-1.42v1.42h-1.19Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5,25.69c2.81,0,5.09-2.28,5.09-5.09s-2.28-5.09-5.09-5.09-5.09,2.28-5.09,5.09,2.28,5.09,5.09,5.09Zm0-6.37c.71,0,1.28,.57,1.28,1.28s-.57,1.28-1.28,1.28-1.28-.57-1.28-1.28,.57-1.28,1.28-1.28Z",
    fill: outlineColor
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 48,
    height: 48,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAddImage);
export default __webpack_public_path__ + "static/media/ico-add-image.8f6542b906c4cd15f32509dcdd0dce4e.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = true;